module.exports = __webpack_public_path__ + "static/media/reviewdale.8bd65251.svg";